<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Отчет по комиссарам"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-file-document"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Отчет по комиссарам
        </div>
      </template>
      <v-row>
        <v-col cols="8">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            label="Поиск"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        multi-sort
        :footerProps="datatable_footer"
      >
       <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.from"
                    label="Дата начала"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.to"
                    label="Дата конца"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    min-width="150"
                    @click="load(false, 3)"
                  >
                    Показать
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    min-width="250"
                    @click="load(true, 3)"
                  >
                    Выгрузить отчет по комиссарам
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:item.date="{item}">
          {{ format(item.date) }}
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      headers: [
        {
          text: 'Комиссар',
          value: 'name',
        },
        {
          text: 'Количество ДТП',
          value: 'accidents',
        },
        {
          text: 'Количество оформленных договоров цессии',
          value: 'cessions',
        },
        {
          text: 'Количество договоров на оформление',
          value: 'documents',
        },
        {
          text: 'Неопределенные ДТП',
          value: 'other',
        },
        {
          text: 'Финансовый результат',
          value: 'sum',
        },
      ],
      items: [],
      search: undefined,
      form: {
        transactions: true,
        date: {
          from: '',
          to: '',
        },
        kind: 0,
        state: 5,
      },
      select: {
        state: [
          { value: 1, text: 'Новый' },
          { value: 2, text: 'Осмотр назначен' },
          { value: 3, text: 'Осмотр проведен' },
          { value: 4, text: 'Документы сданы в СК' },
          { value: 5, text: 'Выплата согласована СК' },
          { value: 6, text: 'Деньги получены от СК' },
          { value: 7, text: 'Передано в архив' },
          { value: 8, text: 'Удален' },
          { value: 9, text: 'Ремонт завершен' },
          { value: 10, text: 'Расторгнут'}
        ],
        kind: [
          { value: 1, text: 'Оформление документов' },
          { value: 2, text: 'Договор Цессии' },
        ],
      },
      dict: {
        state: {
          1: 'Новый',
          2: 'Осмотр назначен',
          3: 'Осмотр проведен',
          4: 'Документы сданы в СК',
          5: 'Выплата согласована СК',
          6: 'Деньги получены от СК',
          7: 'Передано в архив',
          8: 'Удален',
          9: 'Ремонт завершен',
          10: 'Расторгнут'
        },
        kind: {
          1: 'Оформление документов',
          2: 'Договор Цессии',
        },
        type: {},
      },
    }),
    mounted: function () {
      this.load(false, 3)
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
    },
    methods: {
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract_date: function (date) {
        return moment(date).format('DDMM')
      },
      load: function (exp, number) {
        if (exp) {
          let form = $('<form>', {
            target: '_blank',
            action: '/api/report/' + number,
            method: 'post',
          })
          form.append(
            $('<input>', {
              type: 'hidden',
              value: JSON.stringify(this.form),
              name: 'form',
            })
          )
          form.appendTo('body').submit()
        } else {
          this.axios.post('/api/report/show/' + number, this.form)
            .then(result => {
              if (!result.data.error) {
                this.items = result.data.data
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при получении данных')
            })
        }
      },
    },
  }
</script>
